import { BOX as DRAW_BOX, LINE as DRAW_LINE, POLYGON as DRAW_POLYGON } from 'client/utils/constants/symbolName';
import areaBoxPolicy from './AreaBoxValidationPolicy/areaBoxPolicy';
import linearSearchPolicy from './LinearSearchValidationPolicy/linearSearchPolicy';
import customPolygonPolicy from './CustomPolygonValidationPolicy/customPolygonPolicy';

const POLICY_BY_DRAW_SYMBOL = Object.freeze({
    [DRAW_BOX]: areaBoxPolicy,
    [DRAW_LINE]: linearSearchPolicy,
    [DRAW_POLYGON]: customPolygonPolicy
});

export const getValidationPolicy = (drawType) => POLICY_BY_DRAW_SYMBOL[drawType] || null;
